@if (betreff) {
    @if (betreffSmall) {
        <h4 id="nd-betreff-small" class="app-overflow-anywhere">{{ betreff }}</h4>
    } @else {
        <h2 id="nd-betreff" class="app-overflow-anywhere">{{ betreff }}</h2>
    }
}

<div class="row" id="nd-date">
    <div class="col-12 col-sm-3 mb-2 font-bold" id="nd-date-label">{{ 'nachricht.date' | i18next }}:</div>
    <div class="col-12 col-sm-9 mb-2" id="nd-date-content">{{ dateTime }}</div>
</div>

<div class="row" id="nd-sender">
    <div class="col-12 col-sm-3 mb-2 font-bold" id="nd-sender-label">{{ 'nachricht.sender' | i18next }}:</div>
    <div class="col-12 col-sm-9 mb-2" id="nd-sender-content">{{ sender }}</div>
</div>

<div class="row" id="nd-author">
    <div class="col-12 col-sm-3 mb-2 font-bold" id="nd-author-label">{{ 'nachricht.author' | i18next }}:</div>
    <div class="col-12 col-sm-9 mb-2" id="nd-author-content">{{ autor }}</div>
</div>

@if (empfaenger) {
    <div class="row" id="nd-receiver">
        <div class="col-12 col-sm-3 mb-2 font-bold" id="nd-receiver-label"> {{ 'nachricht.receiver' | i18next }}:</div>
        <div class="col-12 col-sm-9 mb-2" id="nd-receiver-content">{{ empfaenger }}</div>
    </div>
}

<div class="row" id="nd-text">
    <div class="col-12 col-sm-3 mb-2 font-bold" id="nd-text-label"> {{ 'nachricht.text' | i18next }}:</div>
    <div class="col-12 col-sm-9 mb-2 ba-copytext app-overflow-anywhere" [innerHTML]="trustedText" id="nd-text-content"></div>
</div>

@if (anhaenge?.length || anhaengeNamen?.length) {
    <div class="row" id="nd-attachment">
        <div class="col-12 col-sm-3 mb-2 font-bold" id="nd-attachment-label">{{ getAttachmentsLabel() }}:</div>

        <div class="col-12 col-sm-9 mb-2" id="nd-attachment-content">
            @if (anhaenge) {
                @for (anhang of anhaenge; track anhang.anhangId; let i = $index; let isLast = $last) {
                    <a href="javascript: void(0)" class="ba-link-icon ba-icon-mail-attachment text-break"
                       (click)="downloadClicked.emit(i)">{{ anhang.dateiname }}
                        , {{ anhang.displayGroesse }}</a>
                    @if (!isLast) {
                        <br/>
                    }
                }
            } @else {
                @for (anhang of anhaengeNamen; track anhang; let i = $index; let isLast = $last) {
                    {{ anhang }}
                    @if (!isLast) {
                        <span>, </span>
                    }
                }
            }
        </div>
    </div>
}

@if (nachrichtActions?.length) {
    <hr class="mx-0 mb-3" aria-hidden="true">
    <pf-nachricht-action-buttons
            [nachrichtActions]="nachrichtActions"
            [nachrichtId]="nachrichtId"
            (buttonClicked)="buttonClicked.emit($event)"
    ></pf-nachricht-action-buttons>
}